(ns frontend.conn
  (:require-macros [cljs.core.async.macros :as async])
  (:require
   [ajax.core :as ax]
   [cljs.core.async :as a]
   [cljs-http.client :as http]
   [promesa.core :as p]
   [promesa.exec :as p-e]
   [z-eines.client :as eines]
   [frontend.db :as db]
   [frontend.logging :as logging]
   [common.timer :as timer]))

(defn state
  []
  (-> @db/app-state
      :conn
      :state
      (or :starting)))

(defn set-state
  [new-state]
  (swap! db/app-state update :conn assoc :state new-state))

(defn has-valid-session!
  []
  (eines/authenticated! true))

(defn init!
  [url dispatch conn-listener on-connect! on-expired! skip-reconnect?]
  (when (-> @db/app-state
            :conn
            :state
            (not= :open))
    (eines/init!
     {:url        url
      :on-message (fn [{:keys [id body server-time device-type expires-in health] :as msg}]
                    (when device-type
                      (do
                        (swap! db/session assoc :device-type device-type)))
                    (when server-time
                      (do
                        (swap! db/session assoc :server-time server-time)))
                    (when expires-in
                      (swap! db/session assoc
                             :server-expires-in expires-in
                             :expires-at (+ expires-in (.getTime (js/Date.))))
                      (deref db/session)
                      (logging/debug "Update expiry"
                                     "\nExpires at : "
                                     (js/Date. (:expires-at @db/session))
                                     "\nExpires in : "
                                     (int (/ expires-in 1000))
                                     " seconds"))
                    (if (= :health.status/healthy
                           (->> health
                                :health/status))
                      (when (:maintenance @db/session)
                        (swap! db/session dissoc :maintenance))
                      (when (:error health)
                        (swap! db/session assoc :maintenance (:error health))))
                    (if (= (:message msg) "Session expired!")
                      (when (fn? on-expired!)
                        (on-expired!))
                      (dispatch id body)))
      :on-connect (fn []
                    (logging/info "conn: on-connect")
                    (set-state :open)
                    (conn-listener :websocket.status/open)
                    (on-connect!))
      :on-error   (fn [err]
                    (logging/info (str "conn: on-error [" err "]"))
                    (case (:code err)
                      502 (logging/error "502 connecting websocket")
                      (logging/info "conn: on-error " err))
                    (if (= err :websocket.status/not-available)
                      (conn-listener err)
                      (conn-listener :websocket.status/error)))
      :on-close   (fn [err]
                    (logging/info "conn: on-close " err)
                    (when (and (not skip-reconnect?)
                               (not= (state) :unloading))
                      (let [timer (timer/create-timer)]
                        ;; try to reconnect every 5 secs
                        (js/setTimeout
                         (fn []
                           (logging/info "Try to reconnect websocket after connection close "
                                         (timer))
                           (init! url dispatch conn-listener on-connect! on-expired! false))
                         5000)))
                    (when (not= (state) :unloading)
                      (set-state :closed))
                    (conn-listener :websocket.status/closed))})))

(defn send!
  ([id body] (send! id body nil 30000))
  ([id body cb] (send! id body cb 30000))
  ([id body cb timeout]
   (send! id body cb timeout false))
  ([id body cb timeout auth?]
   (eines/send!
    {:id   id
     :body body}
    cb
    timeout
    auth?)))

(defn sendp!
  ([id body]
   (sendp! id body 30000 false))
  ([id body timeout]
   (sendp! id body timeout false))
  ([id body timeout auth?]
   (p/create (fn [resolve reject]
               (send! id
                      body
                      (fn [response]
                        (if (:error response)
                          (reject (select-keys response [:error :message :error-code :client-friendly-error-data])) ;(ex-info "Received an error response" {:error error :message message}))
                          (resolve response)))
                      timeout
                      auth?))
             p-e/default-executor)))

(defn sendp-rpc!
  "Promise-based POST to the `/rpc` HTTP endpoint
   (`backend.transport.core/execute-rpc`, the new registered-endpoint
   system) - for operations registered via `backend.endpoint/register-endpoints`
   rather than a legacy domain namespace's `handlers` map, which is what
   `send!`/`sendp!` (eines, a separate transport) dispatch against. Same
   transit wire format `fx.ajax`'s `::send` effect uses for the
   OpenSearch-backed list/kanban operations.

   `ax/ajax-request` is the low-level cljs-ajax API: it has no
   `:error-handler` (that's only on the `GET`/`POST` convenience macros) -
   its single `:handler` always fires with a `[ok? response]` pair, success
   or failure alike. Branch on that pair, same as `fx.ajax`'s
   `classify-reply`."
  ([operation body]
   (sendp-rpc! operation body 30000))
  ([operation body timeout]
   (p/create
    (fn [resolve reject]
      (ax/ajax-request
       {:method           :post
        :uri              "/rpc"
        :headers          {"Content-Type" "application/transit+json"
                           "Accept"       "application/transit+json"}
        :params           {:operation operation :body body}
        :timeout          timeout
        :format           (ax/transit-request-format)
        :response-format  (ax/transit-response-format)
        :handler          (fn [[ok? response]]
                            (if (and ok? (not (:error response)))
                              (resolve response)
                              (reject (if (map? response)
                                        (select-keys response [:error :message :error-code :client-friendly-error-data])
                                        response))))}))
    p-e/default-executor)))

(defn upload-user-image
  [token user-account-id logo]
  (async/go
    (let [resp (a/<!
                (http/post
                 "/logo/api/add-user-image"
                 {:multipart-params (assoc logo :token token :user-account-id user-account-id)}))]
      (:body resp))))

(defn add-user-image!
  "Returns promise for logo upload"
  [logo user-account-id]
  (-> (sendp! :token/create-op-token nil) ;; TODO - can be removed since https session is authenticated with session cookie
      (p/then (fn [resp]
                (upload-user-image (-> resp
                                       :body
                                       :token)
                                   user-account-id
                                   logo)
                nil))))

;;;

(defn upload-logo
  [token file-data callback]
  (async/go
    (let [resp (a/<! (http/post "/logo/api/add-public-file"
                                {:multipart-params (assoc file-data
                                                          :token
                                                          token)}))]
      (callback resp))))

(defn add-logo!
  "Returns promise for logo upload"
  [logo callback!]
  (-> (sendp! :token/create-op-token nil) ;; TODO - can be removed since https session is authenticated with session cookie
      (p/then (fn [resp]
                (upload-logo (-> resp
                                 :body
                                 :token)
                             logo
                             callback!)))))

;;adding a logo for given tenant (by zadmin)
(defn add-logo-for-tenant!
  "Returns promise for logo upload"
  [tenant-id logo callback!]
  (-> (sendp! :token/create-op-token-admin {:tenant-id tenant-id})
      (p/then (fn [resp]
                (upload-logo (-> resp
                                 :body
                                 :token)
                             logo
                             callback!)))))

;;; import file

(defn upload-import
  [token file field callback]
  (async/go
    (let [resp (a/<! (http/post "/dataimport/api/upload-import"
                                {:multipart-params (assoc file
                                                          :token token
                                                          :tenant-field (subs (str field) 1))}))]
      (callback (:body resp)))))

(defn upload-import-file!
  "Returns promise for import file upload"
  [file field callback]
  (-> (sendp! :token/create-op-token nil)
      (p/then (fn [resp]
                (upload-import (-> resp
                                   :body
                                   :token)
                               file
                               field
                               callback)
                nil))))

(defn refresh-session!
  []
  (send! :session/refresh {} (fn [args])))
